import { render, staticRenderFns } from "./enroll.vue?vue&type=template&id=36296a56&scoped=true"
import script from "./enroll.vue?vue&type=script&lang=js"
export * from "./enroll.vue?vue&type=script&lang=js"
import style0 from "./enroll.vue?vue&type=style&index=0&id=36296a56&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36296a56",
  null
  
)

export default component.exports